/**
 * Flexgate Directus (`/items/wallboard_trip_partner`, awards, leagues).
 * Vue CLI env values are strings — only the exact "true" enables them.
 * When off, badge/logo slots use PLACEHOLDER_IMAGE instead of calling Flexgate.
 */
export const PLACEHOLDER_IMAGE = "/img/placeholder.svg";

export function isFlexgateEnabled() {
  return String(process.env.VUE_APP_FLEXGATE_ENABLED || "").toLowerCase() === "true";
}

export function imageSrc(url) {
  return url || PLACEHOLDER_IMAGE;
}

/**
 * Champions/Diamond compliance URL.
 * Konnektor wallboard: `?league_id=` (or `&` if the base already has a query).
 * Flexgate Directus: keep the existing `&filter={"league_id":{"_eq":N}}` suffix.
 */
export function leagueComplianceUrl(base, leagueId) {
  if (!base) return '';
  if (base.includes('/sales/wallboards/compliances')) {
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}league_id=${leagueId}`;
  }
  return `${base}&filter={"league_id":{"_eq":${leagueId}}}`;
}

/**
 * Champions/Diamond reviews URL — Flexgate Directus `&filter=`.
 */
export function leagueReviewsUrl(base, leagueId) {
  if (!base) return '';
  return `${base}&filter={"league_id":{"_eq":${leagueId}}}`;
}
